import { apiService, ServiceSingletonType } from 'app/utils/api.service';
import { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios';
import { authStorage } from 'pages/Auth/helpers';

const isGettingRefData = (url: string) => {
  return /refData/i.test(url);
};

export const handleResponseSuccess = (
  response: AxiosResponse
): Promise<AxiosResponse> => {
  return Promise.resolve(response);
};

export const handleResponseFailure = async (
  error: AxiosError
): Promise<AxiosError | AxiosRequestConfig | any> => {
  if (error.response?.status !== 401) return Promise.reject(error);
  const originalConfig = error.config;
  try {
    const refreshToken = authStorage.getRefreshToken();
    if (!refreshToken) throw new Error('');
    const { data } = await apiService.post(
      `${process.env.REACT_APP_API}auth/accessToken`,
      null,
      {
        headers: {
          ...error.config.headers,
          Authorization: `Bearer ${refreshToken}`
        }
      }
    );
    authStorage.setToken(data.data.accessToken);
    return Promise.resolve(originalConfig);
  } catch (error) {
    authStorage.clear();
    window.location.href = '/';
  }
};

export const getCurrentToken: AppThunk<string> = () => () => {
  const token = authStorage.getToken();
  return `Bearer ${token || ''}`;
};

export function handleRequestSuccess(
  this: ServiceSingletonType,
  config: any
): Promise<AxiosRequestConfig> {
  const {
    url = '',
    headers: { Authorization: existingAuthorization }
  } = config;
  if (isGettingRefData(url)) {
    config.baseURL = process.env.PUBLIC_URL || '/';
  } else {
    config.baseURL = process.env.REACT_APP_API;
  }

  return Promise.resolve({
    ...config,
    headers: {
      ...config.headers,
      Authorization:
        existingAuthorization ||
        this.dispatch<ReturnType<any>>(getCurrentToken()),
      'Access-Control-Allow-Origin': '*'
    }
  });
}

export const handleRequestFailure = (error: AxiosError): Promise<Error> => {
  return Promise.reject(error.request);
};
